import { ContactButton } from 'common/styles/SecondaryModalProduct.style';
import React from 'react';

const ContactUs = () => (
  <ContactButton href="https://www.autronicafire.com/en/contact-us/" target="_blank" rel="noopener">
    Contact Us
  </ContactButton>
);

export default ContactUs;
